
import { Switch } from "@/components/ui/switch";
import { SchoolUser } from "@/types/users";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface UserApprovalSwitchProps {
  user: SchoolUser;
  onUserUpdated: () => void;
}

export const UserApprovalSwitch = ({ user, onUserUpdated }: UserApprovalSwitchProps) => {
  const { toast } = useToast();

  const handleApprovalChange = async () => {
    try {
      const { data, error } = await supabase
        .from('school_users')
        .update({ approved: !user.approved })
        .eq('id', user.id);

      if (error) throw error;

      toast({
        title: "Success",
        description: `User ${user.approved ? 'unapproved' : 'approved'} successfully`,
      });
      
      onUserUpdated();
    } catch (error: any) {
      console.error('Error updating user approval:', error);
      toast({
        title: "Error",
        description: "Failed to update user approval status",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <Switch
        checked={user.approved}
        onCheckedChange={handleApprovalChange}
        aria-label="User approval status"
      />
      <span className="text-sm text-gray-500">
        {user.approved ? 'Approved' : 'Unapproved'}
      </span>
    </div>
  );
};
